import Vue from 'vue'
import { mapActions } from 'vuex'

import { Services, getServicePathToAPI } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services.registration)

export default {
  name: 'RegistrationTemplate',

  data() {
    return {
      payload: {
        username: undefined,
        password: undefined,
        data: {
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          phone: undefined,
          meta: {
            source: window.location.hostname,
            salon_id: undefined,
            usedReferralCode: undefined
          }
        }
      },

      loading: false,
      formValidation: false,

      errors: {}
    }
  },

  watch: {
    $route: {
      handler: 'setMeta',
      deep: true
    },

    'payload.username'() {
      this.$delete(this.errors, 'username')
    }
  },

  mounted() {
    this.setMeta()
  },

  beforeDestroy() {
    window.history.replaceState(null, null, window.location.pathname)
  },

  methods: {
    ...mapActions({ login: 'login/login' }),

    async registration() {
      if (this.formValidation) {
        try {
          this.loading = true

          if (window.roistat?.getVisit) {
            this.payload.$roistat = window.roistat.getVisit()
          }

          const { id } = await request.create(pathToAPI, { body: this.payload })
          if (id) {
            this.login({
              username: this.payload.username,
              password: this.payload.password
            })
          }
        } catch (error) {
          switch (error?.code || error?.error) {
            case 422: {
              if (Array.isArray(error.data) && error.data.length) {
                for (const item of error.data) {
                  const translate = this.getTranslate(`${Services.registration}.errors.${item.field}`)
                  Vue.set(this.errors, item.field, translate || item.message)
                  this.addSnackbar({
                    text: translate || item.message,
                    type: 'error'
                  })
                }
              }

              return
            }
            default: return globalErrorHandler(error)
          }
        } finally {
          this.loading = false
        }
      }
    },

    setMeta() {
      const search = window.location.search.replace('?', '').split('&')
      for (const s of search) {
        const [ key, value ] = s.split('=')
        switch (key) {
          case 'ref': {
            this.payload.data.meta.usedReferralCode = value
            break
          }
          case 'source':
          case 'salon_id': {
            this.payload.data.meta[key] = value
            break
          }
        }
      }
    }
  },

  render
}
